const ru: Record<string, string> = {
  'nav.blog': 'Блог',
  'nav.virtualOffice': 'Виртуальный офис',
  'nav.coworking': 'Коворкинг',
  'nav.accounting': 'Бухгалтерия и право',
  'nav.contact': 'Контакт',
  'nav.clientPortal': 'Портал клиента',
  'nav.getStarted': 'Начать',
  'nav.menu': 'Меню навигации',
  'hero.badge': 'Доверие 400+ компаний из 7 стран',
  'hero.title1': 'Виртуальный офис в Белграде',
  'hero.title2': 'для иностранных и местных компаний',
  'hero.title3': '',
  'hero.desc': 'Открываете или переносите компанию в Сербию и не уверены, соответствует ли адрес требованиям и пройдёт ли он в APR? Вы получаете 100% легальный деловой адрес, регистрацию и администрирование в соответствии с законами Сербии, активные в течение 48 часов после подписания.',
  'hero.trust1': 'Деловой адрес в Белграде и Ковине (налоговая Панчево); Лозница скоро, сообщите об интересе',
  'hero.trust2': 'Помощь в открытии фирмы в Сербии',
  'hero.trust3': 'Приём и пересылка почты',
  'hero.trust4': 'Бухгалтерия и административная поддержка',
  'hero.cta1': 'Начните вести бизнес в Сербии уже сегодня',
  'hero.cta2': 'Как это работает',
  'hero.reviews': 'из 180+ проверенных отзывов клиентов',
  'hero.clientPortal': 'Портал клиента',
  'hero.active': 'Активен',
  'hero.documents': 'Документы',
  'hero.invoices': 'Счета',
  'hero.plan': 'Тариф',
  'hero.address': 'Адрес',
  'hero.liveActivity': 'Активность',
  'hero.docUploaded': 'Новый документ загружен',
  'hero.invoicePaid': 'Счёт оплачен',
  'hero.mailForwarded': 'Почта переслана',
  'hero.newClients': '12 новых клиентов',
  'hero.thisMonth': 'В этом месяце',
  'hero.mockCompany': 'EVI Solutions DOO',
  'hero.activityCompany1': 'Tehno sistem d.o.o.',
  'hero.activityCompany2': 'Jadran trade d.o.o.',
  'hero.activityCompany3': 'Stojanović consulting d.o.o.',
  'hero.timeAgo2m': '2 мин назад',
  'hero.timeAgo18m': '18 мин назад',
  'hero.timeAgo1h': '1 ч назад',
  'hero.kpi.documentsSub': '2 новых на этой неделе',
  'hero.kpi.invoicesSub': '1 ожидает оплаты',
  'hero.kpi.planSub': 'Виртуальный офис',
  'hero.kpi.addressValue': 'Белград',
  'hero.kpi.addressSub': 'Топчидерска 14',
  'services.tag': 'Что мы предлагаем',
  'services.title': 'Деловой адрес, приём почты и\nбухгалтерия в одном месте',
  'services.desc':
    'Для иностранных компаний и местных предпринимателей: офисные решения Top14 закрывают регистрацию, адрес и сопровождение.',
  'services.mostPopular': 'Самое популярное',
  'services.virtualOffice.tag': 'Деловой адрес и регистрация',
  'services.virtualOffice.title': 'Виртуальный офис',
  'services.virtualOffice.desc':
    'Зарегистрированные деловые адреса в Белграде (Топчидерская) и Ковине (налоговая Панчево). Локация Лозница скоро, сообщите об интересе. Включает обработку почты, поддержку регистрации компании и защищённый портал документов.',
  'services.virtualOffice.taxNote':
    'Альтернативные локации могут дополнительно помочь налоговой оптимизации в зависимости от вашей модели бизнеса.',
  'services.virtualOffice.f1': 'Белград – Топчидерская, община Савски венац',
  'services.virtualOffice.f5': 'Ковин, налоговая Панчево - самый выгодный патент в Сербии',
  'services.virtualOffice.f6': 'Лозница, скоро, близко к границе с БиГ (сообщите об интересе)',
  'services.virtualOffice.f2': 'Поддержка регистрации в APR',
  'services.virtualOffice.f3': 'Подходит для иностранных компаний',
  'services.virtualOffice.f4': 'Портал управления документами',
  'services.virtualOffice.price': '3 500 RSD',
  'services.virtualOffice.per': '/ месяц (~30 EUR)',
  'services.virtualOffice.learn': 'Узнать больше',
  'services.coworking.tag': 'Гибкое рабочее пространство',
  'services.coworking.title': 'Коворкинг',
  'services.coworking.desc': 'Современные рабочие места и частные офисы в центре Белграда. Гигабитный интернет 1 Гбит/с, 3 переговорные комнаты и тихое пространство максимум на 20 человек.',
  'services.coworking.price': '€89',
  'services.coworking.per': '/ месяц',
  'services.coworking.plans': 'Посмотреть тарифы',
  'services.accounting.tag': 'Деловая поддержка',
  'services.accounting.title': 'Бухгалтерия и право',
  'services.accounting.desc': 'Бухгалтерский учёт, регистрация НДС, налоговые декларации и юридические консультации.',
  'services.accounting.cta': 'Бесплатная консультация',
  'capitaale.aria': 'Рекомендуемое приложение для предпринимателей на паушале',
  'capitaale.tag': 'Рекомендуем для предпринимателей на паушале',
  'capitaale.desc':
    'Capitaale — приложение для предпринимателей, которые выставляют счета иностранным клиентам. Реальный баланс в динарах после курса банка, лимит паушала в реальном времени, предупреждение когда один клиент превышает 70% дохода, и счёт в EUR или USD за 60 секунд. Первые 7 дней бесплатно.',
  'capitaale.cta': 'Попробовать 7 дней бесплатно',
  'capitaale.external': 'Открывает партнёрскую страницу Capitaale',
  'how.tag': 'Шаг за шагом',
  'how.title': 'Как вы запускаете бизнес в Сербии с нами',
  'how.desc':
    'Сопровождаем вас на всём пути: от первой идеи до полноценно работающей компании, без сложностей и потери времени.',
  'how.step1.title': 'Краткая консультация по телефону',
  'how.step1.lead': 'Узнаём ваши задачи и предлагаем оптимальное решение',
  'how.step1.desc':
    'Обсуждаем ваш бизнес, цели и масштаб деятельности в Сербии и на этой основе предлагаем подходящий пакет услуг.',
  'how.step1.badge': '15–30 мин',
  'how.step2.title': 'Предложение и договор',
  'how.step2.lead': 'Вы получаете понятный план и все условия заранее',
  'how.step2.desc':
    'Отправляем конкретное коммерческое предложение и образец договора. Всё прозрачно, без скрытых расходов.',
  'how.step2.check1': 'чётко определено',
  'how.step2.check2': 'минимум бюрократии',
  'how.step3.title': 'Разрешение на деловой адрес',
  'how.step3.lead': 'Вы получаете согласие на использование нашего адреса как юридического',
  'how.step3.intro': 'От нас вы получаете:',
  'how.step3.bullet1': 'разрешение на регистрацию нашего адреса в APR',
  'how.step3.bullet2': 'документы, необходимые для юридического адреса',
  'how.step3.bullet3': 'приём почты по этому адресу',
  'how.step3.badge': 'обычно несколько дней',
  'how.step4.title': 'Активация и работа в портале',
  'how.step4.lead': 'Дальше всё решаете в одном месте',
  'how.step4.desc': 'После подписания открываем вам доступ к порталу, где вы можете:',
  'how.step4.bullet1': 'управлять документами',
  'how.step4.bullet2': 'общаться с командой',
  'how.step4.bullet3': 'отслеживать счета и услуги',
  'how.step4.badge': 'поддержка 24/7',
  'how.cta': 'Запустите бизнес без лишних сложностей',
  'how.learnMore': 'Узнать больше',
  'vo.tag': 'Виртуальный офис',
  'vo.title': 'Профессиональный белградский\nадрес для вашего бизнеса',
  'vo.desc': 'Зарегистрированный адрес на Топчидерской улице, Белград - идеально для иностранных компаний.',
  'vo.standard': 'Стандарт',
  'vo.premium': 'Премиум',
  'vo.popular': 'Самое популярное',
  'vo.month': '/ месяц',
  'vo.getStarted': 'Начать',
  'vo.contact': 'Связаться',
  'vo.included': 'Включено во все тарифы',
  'cw.tag': 'Коворкинг',
  'cw.title': 'Современные рабочие пространства\nв центре Белграда',
  'cw.desc': 'Гибкие коворкинг-пространства для продуктивной работы.',
  'cw.hotDesk': 'Горячий стол',
  'cw.dedicatedDesk': 'Выделенный стол',
  'cw.privateOffice': 'Частный офис',
  'cw.month': '/ месяц',
  'cw.getStarted': 'Начать',
  'cw.bookTour': 'Записаться на экскурсию',
  'acc.tag': 'Бухгалтерия и право',
  'acc.title': 'Полная финансовая и правовая\nподдержка вашего бизнеса',
  'acc.desc': 'Наша команда опытных бухгалтеров и юридических консультантов.',
  'acc.basic': 'Базовый',
  'acc.professional': 'Профессиональный',
  'acc.enterprise': 'Корпоративный',
  'acc.month': '/ месяц',
  'acc.getStarted': 'Начать',
  'acc.consultation': 'Бесплатная консультация',
  'acc.pricing.title': 'Прайс-лист бухгалтерских услуг',
  'acc.pricing.subtitle': 'Все цены в сербских динарах (RSD). Цены минимальные и подлежат согласованию.',
  'acc.pricing.service': 'Услуга',
  'acc.pricing.clientPrice': 'Цена для клиентов',
  'acc.pricing.regularPrice': 'Обычная цена',
  'acc.pricing.unit': 'Единица / примечание',
  'acc.pricing.online': 'Онлайн',
  'trust.tag': 'Почему Top14',
  'trust.title': 'Доверие компаний\nсо всего мира',
  'trust.desc':
    'Более 400 компаний из 7 стран выбирают офисные решения Top14 для присутствия бизнеса в Сербии.',
  'trust.companies': 'Активных компаний',
  'trust.countries': 'Стран',
  'trust.years': 'Лет опыта',
  'trust.satisfaction': 'Удовлетворённость клиентов',
  'contact.tag': 'Свяжитесь с нами',
  'contact.title': 'Офисные решения Top14',
  'contact.desc': 'Готовы создать сербское деловое присутствие? Напишите нам.',
  'contact.address': 'Адрес',
  'contact.phone': 'Телефон',
  'contact.email': 'Email',
  'contact.hours': 'Рабочее время',
  'contact.hoursValue': 'Пн–Пт, 09:00–17:00 CET',
  'contact.addressValue': 'Топчидерска 14, 11000 Белград, Сербия',
  'contact.phoneValue': '+381 62 262 221',
  'contact.emailValue': 'office@top14.rs',
  'contact.mapStreet': 'улица Топчидерска',
  'contact.mapCity': 'Белград, Сербия',
  'contact.responseTime': 'Типичное время ответа',
  'contact.responseValue': 'До 4 часов в рабочее время',
  'contact.weRespond': 'Мы отвечаем на',
  'contact.formTitle': 'Отправить сообщение',
  'contact.formDesc': 'Мы ответим в течение одного рабочего дня.',
  'contact.name': 'Полное имя *',
  'contact.emailField': 'Email адрес *',
  'contact.phoneField': 'Телефон для связи *',
  'contact.placeholderPhone': '+381 60 123 4567',
  'contact.errPhone': 'Введите номер телефона.',
  'contact.company': 'Название компании',
  'contact.country': 'Страна',
  'contact.officeLocation': 'Локация виртуального офиса *',
  'contact.selectOfficeLocation': 'Выберите локацию…',
  'contact.location.belgrade': 'Белград, Топчидерская - налоговая Савски венац',
  'contact.location.kovinPancevo': 'Ковин - налоговая Панчево (самый выгодный патент в Сербии)',
  'contact.location.loznica': 'Лозница, скоро (рядом с БиГ); сообщите об интересе',
  'contact.location.arandjelovac': 'Аранджеловац',
  'contact.errOfficeLocation': 'Выберите локацию офиса.',
  'contact.service': 'Интересующие услуги *',
  'contact.selectService': 'Выберите услугу...',
  'contact.placeholderName': 'Иван Петров',
  'contact.placeholderEmail': 'ivan@primer.rs',
  'contact.placeholderCompany': 'ООО «Пример», Москва',
  'contact.placeholderCountry': 'Россия',
  'contact.placeholderMessage':
    'Ищем виртуальный офис в Белграде и помощь с регистрацией представительства. Кратко опишите этапы и ориентировочную стоимость.',
  'contact.serviceRequired': 'Выберите хотя бы одну услугу.',
  'contact.errName': 'Введите имя.',
  'contact.errEmail': 'Введите email.',
  'contact.errEmailInvalid': 'Введите корректный email.',
  'contact.errMessage': 'Введите сообщение.',
  'contact.errMessageMin': 'Сообщение должно быть не короче 20 символов.',
  'contact.message': 'Сообщение *',
  'contact.messageHint': 'Опишите ваши бизнес-потребности.',
  'contact.send': 'Отправить',
  'contact.sending': 'Отправка...',
  'contact.successTitle': 'Сообщение отправлено',
  'contact.successDesc': 'Спасибо. Наша команда свяжется с вами в течение одного рабочего дня.',
  'contact.sendAnother': 'Отправить ещё',
  'contact.services.vo': 'Виртуальный офис',
  'contact.services.cw': 'Коворкинг',
  'contact.services.acc': 'Бухгалтерия и право',
  'contact.services.reg': 'Регистрация компании',
  'contact.services.gen': 'Общий запрос',
  'contact.toast': 'Сообщение отправлено! Мы свяжемся с вами в течение одного рабочего дня.',
  'contact.errorSend': 'Не удалось отправить сообщение. Попробуйте ещё раз через минуту.',
  'footer.desc':
    'Top14 - профессиональный виртуальный офис, коворкинг и поддержка бизнеса для компаний в Сербии.',
  'footer.services': 'Услуги',
  'footer.company': 'Компания',
  'footer.contact': 'Контакт',
  'footer.about': 'О нас',
  'footer.howItWorks': 'Как это работает',
  'footer.pricing': 'Цены',
  'footer.clientPortal': 'Портал клиента',
  'footer.privacy': 'Политика конфиденциальности',
  'footer.terms': 'Условия использования',
  'footer.cookies': 'Политика cookies',
  'legal.backHome': 'На главную',
  'footer.rights': '© 2026 EVI Solutions DOO. Все права защищены.',
  'portal.adminDashboard': 'Панель администратора',
  'portal.operatorDashboard': 'Панель оператора',
  'portal.roleBadgeAdmin': 'Администратор',
  'portal.roleBadgeOperator': 'Оператор',
  'portal.roleBadgeClient': 'Клиент',
  'portal.clientDashboard': 'Панель клиента',
  'portal.signOut': 'Выйти',
  'portal.publicSite': 'Публичный сайт',
  'portal.settings': 'Настройки',
  'portal.password.title': 'Смена пароля',
  'portal.password.hint': 'Для входа по email и паролю.',
  'portal.password.current': 'Текущий пароль',
  'portal.password.new': 'Новый пароль',
  'portal.password.confirm': 'Подтвердите новый пароль',
  'portal.password.submit': 'Сохранить пароль',
  'portal.password.saving': 'Сохранение…',
  'portal.password.changed': 'Пароль успешно изменён.',
  'portal.password.wrongCurrent': 'Неверный текущий пароль.',
  'portal.password.mismatch': 'Пароли не совпадают.',
  'portal.password.tooShort': 'Не менее 8 символов.',
  'portal.password.changeFailed': 'Не удалось сменить пароль.',
  'portal.password.noEmail': 'Нет email у аккаунта.',
  'portal.darkMode': 'Тёмная тема',
  'portal.notifications': 'Уведомления',
  'portal.markAllRead': 'Отметить все как прочитанные',
  'portal.viewAll': 'Посмотреть все',
  'portal.notificationsPageTitle': 'Уведомления',
  'portal.notificationsUnreadHint': 'непрочитанных',
  'portal.notificationsAllCaughtUp': 'Всё просмотрено',
  'portal.notificationsEmpty': 'Нет уведомлений.',
  'portal.notificationsLoadError': 'Не удалось загрузить уведомления.',
  'portal.markAllReadDone': 'Всё отмечено как прочитанное.',
  'portal.notificationsNeedCompany': 'Уведомления появятся после загрузки компании.',
  'portal.notif.contactForm': 'Новая заявка из формы: {{name}}',
  'portal.notif.newTask': 'Новая заявка',
  'portal.profile': 'Профиль',
  'portal.search': 'Поиск компаний, документов...',
  'portal.company': 'Компания',
  'portal.contactSupport': 'Связаться с поддержкой',
  'portal.exportReport': 'Экспорт отчёта',
  'portal.addCompany': 'Добавить компанию',
  'portal.language': 'Язык',
  'portal.openMenu': 'Открыть меню',
  'sidebar.main': 'Навигация',
  'sidebar.dashboard': 'Обзор',
  'sidebar.myCompany': 'Моя компания',
  'sidebar.companies': 'Компании',
  'sidebar.documents': 'Документы',
  'sidebar.invoices': 'Счета',
  'sidebar.users': 'Пользователи',
  'sidebar.calls': 'Входящие звонки',
  'sidebar.callsAdmin': 'Телефонные звонки',
  'sidebar.contacts': 'Контактная форма',
  'sidebar.notifications': 'Уведомления',
  'sidebar.tasks': 'Задачи',
  'sidebar.taskRequests': 'Запросы',
  'admin.tab.dashboard': 'Обзор',
  'admin.tab.companies': 'Компании',
  'admin.tab.documents': 'Документы',
  'admin.tab.invoices': 'Счета',
  'admin.tab.users': 'Пользователи',
  'admin.tab.tasks': 'Задачи',
  'admin.tab.calls': 'Звонки',
  'admin.tab.contacts': 'Контактная форма',
  'admin.contacts.title': 'Заявки из контактной формы',
  'admin.contacts.subtitle': 'заявок',
  'admin.contacts.newBadge': 'новых',
  'admin.contacts.unreadBadge': 'непрочит.',
  'admin.contacts.refresh': 'Обновить',
  'admin.contacts.loading': 'Загрузка…',
  'admin.contacts.empty': 'Заявок пока нет.',
  'admin.contacts.loadError': 'Не удалось загрузить заявки.',
  'admin.contacts.updateError': 'Не удалось сохранить.',
  'admin.contacts.statusSaved': 'Статус сохранён.',
  'admin.contacts.noteSaved': 'Заметка сохранена.',
  'admin.contacts.col.date': 'Дата',
  'admin.contacts.col.contact': 'Контакт',
  'admin.contacts.col.office': 'Офис',
  'admin.contacts.col.services': 'Услуги',
  'admin.contacts.col.status': 'Статус',
  'admin.contacts.col.notes': 'Внутренняя заметка',
  'admin.contacts.affiliate': 'Affiliate',
  'admin.contacts.notePlaceholder': 'Договорённости, следующий шаг…',
  'admin.contacts.saveNote': 'Сохранить заметку',
  'admin.contacts.openMessage': 'Сообщение',
  'admin.contacts.close': 'Закрыть',
  'admin.contacts.status.new': 'Новая',
  'admin.contacts.status.contacted': 'Связались',
  'admin.contacts.status.no_show_negotiations': 'Не вышел на связь (переговоры)',
  'admin.contacts.status.in_discussion': 'В переговорах',
  'admin.contacts.status.became_client': 'Стал клиентом',
  'admin.contacts.status.declined': 'Отказ',
  'admin.contacts.status.spam': 'Спам',
  'admin.cancel': 'Отмена',
  'admin.filters.title': 'Фильтры',
  'admin.filters.company': 'Компания',
  'admin.filters.allCompanies': 'Все компании',
  'admin.filters.category': 'Тип документа',
  'admin.filters.allCategories': 'Все типы',
  'admin.filters.status': 'Статус',
  'admin.filters.allStatuses': 'Все статусы',
  'admin.filters.dateFrom': 'С',
  'admin.filters.dateTo': 'По',
  'admin.filters.priority': 'Приоритет',
  'admin.filters.allPriorities': 'Все',
  'admin.filters.reset': 'Сбросить',
  'admin.users.title': 'Управление пользователями',
  'admin.users.total': 'пользователей',
  'admin.users.addUser': 'Добавить пользователя',
  'admin.users.newUser': 'Новый пользователь',
  'admin.users.fullName': 'Полное имя',
  'admin.users.email': 'Email',
  'admin.users.password': 'Пароль',
  'admin.users.roleClient': 'Клиент',
  'admin.users.roleOperator': 'Оператор',
  'admin.users.roleAdmin': 'Администратор',
  'admin.users.operatorCannotEditAdmin': 'Операторы не могут редактировать учётные записи администраторов.',
  'admin.users.operatorCannotAssignAdmin': 'Операторы не могут назначать роль администратора.',
  'admin.users.noCompany': 'Без компании',
  'admin.users.create': 'Создать пользователя',
  'admin.users.creating': 'Создание...',
  'admin.users.created': 'Пользователь создан',
  'admin.users.createFailed': 'Ошибка создания пользователя',
  'admin.users.fillRequired': 'Заполните все обязательные поля',
  'admin.users.passwordMin': 'Пароль должен содержать не менее 8 символов',
  'admin.users.loading': 'Загрузка пользователей...',
  'admin.users.noUsers': 'Пользователи не найдены',
  'admin.users.name': 'Имя',
  'admin.users.emailCol': 'Email',
  'admin.users.roleCol': 'Роль',
  'admin.users.companyCol': 'Компания',
  'admin.users.assignCompany': 'Назначить компанию',
  'admin.users.none': 'Нет',
  'admin.users.assigned': 'Компания назначена',
  'admin.users.assignFailed': 'Ошибка назначения компании',
  'admin.users.actions': 'Действия',
  'admin.users.edit': 'Изменить',
  'admin.users.resetPassword': 'Новый пароль',
  'admin.users.editUser': 'Редактировать пользователя',
  'admin.users.saveChanges': 'Сохранить',
  'admin.users.updated': 'Пользователь обновлён',
  'admin.users.updateFailed': 'Не удалось обновить пользователя',
  'admin.users.activeUser': 'Аккаунт активен',
  'admin.users.resetPasswordTitle': 'Новый пароль',
  'admin.users.newPassword': 'Новый пароль',
  'admin.users.confirmPassword': 'Подтверждение пароля',
  'admin.users.passwordMismatch': 'Пароли не совпадают',
  'admin.users.passwordChanged': 'Пароль сброшен',
  'admin.users.passwordChangeFailed': 'Не удалось сбросить пароль',
  'admin.users.serverConfig':
    'Добавьте SUPABASE_SERVICE_ROLE_KEY на сервер для сброса пароля из панели.',
  'admin.calls.title': 'Телефонные звонки',
  'admin.calls.recent': 'последних записей',
  'admin.calls.addCall': 'Записать звонок',
  'admin.calls.newCall': 'Новый звонок',
  'admin.calls.selectCompany': 'Компания *',
  'admin.calls.caller': 'Звонящий',
  'admin.calls.callerPhone': 'Номер звонящего',
  'admin.calls.reason': 'Причина звонка',
  'admin.calls.priority.low': 'Низкий',
  'admin.calls.priority.medium': 'Средний',
  'admin.calls.priority.high': 'Высокий',
  'admin.calls.duration': 'Длительность (мин., необязательно)',
  'admin.calls.notes': 'Примечания',
  'admin.calls.handledBy': 'Принял / обработал',
  'admin.calls.recording': 'Запись разговора (необязательно)',
  'admin.calls.recordingHint': 'Прикрепить аудио (MP3, WAV, M4A…)',
  'admin.calls.save': 'Сохранить звонок',
  'admin.calls.saving': 'Сохранение…',
  'admin.calls.saved': 'Звонок сохранён',
  'admin.calls.saveFailed': 'Не удалось сохранить звонок',
  'admin.calls.fillRequired': 'Укажите компанию, звонящего, номер и причину',
  'admin.calls.loading': 'Загрузка…',
  'admin.calls.noCalls': 'Звонков пока нет',
  'admin.calls.deleted': 'Звонок удалён',
  'admin.calls.deleteFailed': 'Не удалось удалить звонок',
  'admin.calls.openRecording': 'Воспроизвести запись',
  'admin.calls.storageFailed': 'Не удалось загрузить запись',
  'admin.calls.delete': 'Удалить звонок',
  'admin.docs.title': 'Управление документами',
  'admin.docs.recent': 'последних документов',
  'admin.docs.addDoc': 'Добавить документ',
  'admin.docs.newDoc': 'Новый документ',
  'admin.docs.selectCompany': 'Выберите компанию *',
  'admin.docs.docName': 'Название документа',
  'admin.docs.description': 'Описание документа',
  'admin.docs.uploadPdf': 'Загрузить PDF файл',
  'admin.docs.category': 'Категория',
  'admin.docs.fileUrl': 'URL файла (необязательно)',
  'admin.docs.fileSize': 'Размер файла (напр. 284 KB)',
  'admin.docs.save': 'Сохранить документ',
  'admin.docs.saving': 'Сохранение...',
  'admin.docs.uploaded': 'Документ добавлен',
  'admin.docs.uploadFailed': 'Ошибка добавления документа',
  'admin.docs.fillRequired': 'Компания и название документа обязательны',
  'admin.docs.operatorNoInvoiceCategory': 'Операторы не могут загружать документы в категории «Счета».',
  'admin.docs.loading': 'Загрузка документов...',
  'admin.docs.noDocs': 'Документов нет',
  'admin.docs.deleted': 'Документ удалён',
  'admin.docs.deleteFailed': 'Ошибка удаления документа',
  'admin.docs.storageUploadFailed': 'Не удалось загрузить файл в хранилище',
  'admin.docs.open': 'Открыть',
  'admin.docs.noFile': 'Для этой записи файл не сохранён.',
  'admin.docs.openFailed': 'Не удалось открыть файл.',
  'admin.docs.deleteFileFailed': 'Не удалось удалить файл из хранилища',
  'admin.docs.cat.company': 'Документы компании',
  'admin.docs.cat.archive': 'Архивная книга',
  'admin.docs.cat.mail': 'Входящая почта',
  'admin.docs.cat.tax': 'Налоговый ящик',
  'admin.docs.cat.registration': 'Регистрация',
  'admin.docs.cat.lease': 'Аренда',
  'admin.docs.cat.accounting': 'Бухгалтерия',
  'admin.docs.cat.other': 'Прочее',

  'docCat.CompanyLegal': 'Регистрационные документы (APR, устав, решения)',
  'docCat.StatutoryArchive': 'Архив и обязательное хранение',
  'docCat.MailForwarding': 'Почта и пересылка (сканы, входящая корреспонденция)',
  'docCat.TaxCompliance': 'Налоги, взносы и отчётность',
  'docCat.ContractsLeases': 'Договоры и аренда',
  'docCat.VirtualOfficeServices': 'Услуги виртуального офиса',
  'docCat.Accounting': 'Бухгалтерия и отчётность',
  'docCat.Invoices': 'Счета',
  'docCat.Other': 'Прочее',
  'admin.invoices.title': 'Управление счетами',
  'admin.invoices.recent': 'последних счетов',
  'admin.invoices.issue': 'Выставить счёт',
  'admin.invoices.newInvoice': 'Новый счёт',
  'admin.invoices.selectCompany': 'Выберите компанию *',
  'admin.invoices.description': 'Описание',
  'admin.invoices.amount': 'Сумма',
  'admin.invoices.dueDate': 'Срок оплаты',
  'admin.invoices.create': 'Создать счёт',
  'admin.invoices.creating': 'Создание...',
  'admin.invoices.created': 'Счёт создан',
  'admin.invoices.createFailed': 'Ошибка создания счёта',
  'admin.invoices.fillRequired': 'Заполните все обязательные поля',
  'admin.invoices.loading': 'Загрузка счетов...',
  'admin.invoices.noInvoices': 'Счетов нет',
  'admin.invoices.number': 'Номер счёта',
  'admin.invoices.companyCol': 'Компания',
  'admin.invoices.descCol': 'Описание',
  'admin.invoices.amountCol': 'Сумма',
  'admin.invoices.statusCol': 'Статус',
  'admin.invoices.markedPaid': 'Отмечено как оплачено',
  'admin.invoices.updateFailed': 'Ошибка обновления счёта',
  'admin.invoices.deleted': 'Счёт удалён',
  'admin.invoices.deleteFailed': 'Ошибка удаления счёта',
  'admin.invoices.invoiceNumberLabel': 'Номер счёта (вручную)',
  'admin.invoices.issueDate': 'Дата выставления',
  'admin.invoices.attachmentLabel': 'Вложение счёта (PDF или изображение)',
  'admin.invoices.attachmentHint': 'Клиент увидит файл в портале в разделе документов.',
  'admin.invoices.chooseFile': 'Выбрать файл',
  'admin.invoices.uploadingDoc': 'Загрузка вложения...',
  'admin.invoices.duplicateNumber': 'Такой номер счёта уже существует.',
  'admin.invoices.documentUploadFailed': 'Счёт создан, но загрузка вложения не удалась',
  'admin.invoices.statusUpdated': 'Статус счёта обновлён',
  'admin.invoices.changeStatus': 'Изменить статус',
  'admin.invoices.deleteInvoice': 'Удалить счёт',
  'admin.invoices.editInvoice': 'Изменить счёт',
  'admin.invoices.saveChanges': 'Сохранить изменения',
  'admin.invoices.saving': 'Сохранение...',
  'admin.invoices.updated': 'Счёт обновлён',
  'admin.invoices.stPending': 'Ожидает',
  'admin.invoices.stPaid': 'Оплачен',
  'admin.invoices.stOverdue': 'Просрочен',
  'admin.invoices.stCancelled': 'Отменён',
  'admin.companies.businessAddress': 'Деловой адрес',
  'admin.companies.taxAddress': 'Налоговый адрес / Отдельное подразделение',
  'admin.companies.accountManager': 'Менеджер по работе с клиентами',
  'admin.companies.accountManagerEmail': 'Email менеджера',
  'admin.companies.accountManagerPhone': 'Телефон менеджера',
  'admin.companies.phone': 'Телефон компании',
  'admin.companies.email': 'Email компании',
  'admin.companies.regNumber': 'Регистрационный номер',
  'admin.companies.notes': 'Примечания',
  'admin.companies.sectionCompany': 'Компания',
  'admin.companies.sectionManager': 'Менеджер по работе с клиентами',
  'admin.companies.companyName': 'Название компании',
  'admin.companies.country': 'Страна',
  'admin.companies.registrationAddress': 'Адрес и город регистрации',
  'admin.companies.aprEmail': 'Официальный email для APR',
  'admin.companies.aprPhone': 'Официальный телефон для APR',
  'admin.companies.ownerPhone': 'Прямой телефон владельца',
  'admin.companies.ownerEmail': 'Прямой email владельца',
  'admin.companies.pib': 'ИНН (PIB)',
  'admin.companies.companyRegistrationDate': 'Дата регистрации компании',
  'admin.companies.portalRegistrationDate': 'Дата регистрации в портале',
  'admin.companies.managerName': 'Имя менеджера',
  'admin.companies.managerEmail': 'Email менеджера',
  'admin.companies.managerContactPhone': 'Контактный телефон',
  'admin.tasks.title': 'Запросы',
  'admin.tasks.noTasks': 'Нет запросов',
  'admin.tasks.pending': 'В ожидании',
  'admin.tasks.submitted': 'Запрос подан',
  'admin.tasks.ticketUrlPlaceholder': 'https://... ссылка на тикет бухгалтера',
  'admin.tasks.saveUrl': 'Сохранить ссылку',
  'admin.tasks.openTicket': 'Открыть тикет',
  'admin.tasks.urlSaved': 'Ссылка сохранена.',
  'admin.tasks.urlSaveFailed': 'Не удалось сохранить ссылку.',
  'admin.tasks.targetAccountant': 'Бухгалтер',
  'admin.tasks.targetSupport': 'Поддержка',
  'admin.tasks.urgency': 'Срочность',
  'admin.tasks.contactPref': 'Контакт',
  'admin.tasks.tabAccountant': 'Бухгалтер',
  'admin.tasks.tabSupport': 'Поддержка',
  'admin.tasks.emptyAccountant': 'Пока нет запросов бухгалтеру.',
  'admin.tasks.emptySupport': 'Пока нет запросов в поддержку.',
  'admin.tasks.supportStatusReceived': 'Принято',
  'admin.tasks.supportStatusInProgress': 'В работе',
  'admin.tasks.supportStatusCompleted': 'Завершено',
  'admin.tasks.supportStatusLabel': 'Статус',
  'admin.tasks.supportStatusSaved': 'Статус обновлён.',
  'admin.tasks.supportStatusSaveFailed': 'Не удалось обновить статус.',
  'client.docs.title': 'Документы компании',
  'client.docs.statsLine': '{{count}} документов · {{new}} новых',
  'client.docs.search': 'Поиск документов...',
  'client.docs.all': 'Все категории',
  'client.docs.dateFrom': 'С даты',
  'client.docs.dateTo': 'По дату',
  'client.docs.clearDates': 'Сбросить даты',
  'client.docs.noResults': 'Документы не найдены',
  'client.docs.adjustSearch': 'Попробуйте изменить поиск',
  'client.docs.download': 'Скачать',
  'client.docs.preview': 'Просмотр',
  'client.docs.noFile': 'Файл недоступен.',
  'client.docs.openFailed': 'Не удалось открыть файл.',
  'client.docs.invoiceBadge': 'Счёт',
  'client.docs.loading': 'Загрузка документов...',
  'client.docs.loadFailed': 'Не удалось загрузить документы.',
  'client.docs.uploadTitle': 'Загрузить документ',
  'client.docs.uploadHint': 'Загрузите файл, связанный с вашей компанией. Поддерживаются PDF, изображения и офисные форматы.',
  'client.docs.docNamePlaceholder': 'Название документа (необязательно)',
  'client.docs.chooseFile': 'Выбрать файл',
  'client.docs.uploading': 'Загрузка...',
  'client.docs.submitUpload': 'Отправить документ',
  'client.docs.uploaded': 'Документ загружен',
  'client.docs.uploadFailed': 'Ошибка загрузки',
  'client.docs.fillRequired': 'Выберите файл.',
  'client.invoices.title': 'Счета и платежи',
  'client.company.address': 'Деловой адрес',
  'client.company.taxAddress': 'Налоговый адрес / Отд. подразделение',
  'client.company.fieldNotSet': 'Не указано',
  'client.company.country': 'Страна',
  'client.company.registrationAddress': 'Адрес и город регистрации',
  'client.company.companyEmail': 'Email компании',
  'client.company.aprEmail': 'Официальный email APR',
  'client.company.aprPhone': 'Официальный телефон APR',
  'client.company.ownerPhone': 'Телефон владельца',
  'client.company.ownerEmail': 'Email владельца',
  'client.company.pib': 'ИНН (PIB)',
  'client.company.notesCompany': 'Примечания',
  'client.company.companyRegDate': 'Дата регистрации компании',
  'client.company.portalRegDate': 'Дата регистрации в портале',
  'client.company.start': 'Начало обслуживания',
  'client.company.renewal': 'Следующее продление',
  'client.company.plan': 'Тариф',
  'client.company.manager': 'Ваш менеджер',
  'client.company.noCompany': 'Компания не назначена.',
  'client.company.contactManager': 'Свяжитесь с менеджером для помощи.',
  'company.plan.group.vo': 'Виртуальный офис',
  'company.plan.group.cw': 'Коворкинг',
  'company.plan.vo_starter': 'Стартер',
  'company.plan.vo_business': 'Бизнес',
  'company.plan.vo_premium': 'Премиум',
  'company.plan.cw_hot_desk': 'Хот-деск',
  'company.plan.cw_fixed_desk': 'Фиксированное место',
  'company.plan.cw_private_office': 'Частный офис',
  'client.kpi.docs': 'Всего документов',
  'client.kpi.invoices': 'Активные счета',
  'client.kpi.overdue': 'Просроченные счета',
  'client.kpi.renewal': 'Следующее продление',
  'client.kpi.docsSub': '{{count}} новых за месяц',
  'client.kpi.invoicesSub': '{{count}} ожидают оплаты',
  'client.kpi.overdueSubOk': 'Все счета в срок',
  'client.kpi.overdueSubAction': 'Требуется действие',
  'client.kpi.renewalValueDays': '{{count}} дн.',
  'client.kpi.renewalDue': 'Срок: {{date}}',
  'client.kpi.renewalSubNone': 'Продление не задано',
  'client.calls.title': 'Входящие звонки',
  'client.calls.caller': 'Звонящий',
  'client.calls.phone': 'Телефон',
  'client.calls.date': 'Дата и время',
  'client.calls.duration': 'Длительность',
  'client.calls.notes': 'Примечания',
  'client.calls.noCalls': 'Нет входящих звонков',
  'client.calls.minutes': 'мин',
  'client.calls.reason': 'Причина',
  'client.calls.priorityLow': 'Низкий приоритет',
  'client.calls.priorityMedium': 'Средний приоритет',
  'client.calls.priorityHigh': 'Высокий приоритет',
  'client.calls.openRecording': 'Прослушать запись',
  'client.calls.openRecordingFailed': 'Не удалось открыть запись',
  'client.task.button': 'Отправить запрос бухгалтеру',
  'client.task.title': 'Новый запрос для бухгалтера',
  'client.task.subtitle': 'Опишите задачу. Референсный прайс откройте при необходимости.',
  'client.task.taskTitle': 'Название запроса',
  'client.task.taskDesc': 'Описание запроса',
  'client.task.send': 'Отправить запрос',
  'client.task.sending': 'Отправка...',
  'client.task.sent': 'Запрос отправлен!',
  'client.task.failed': 'Ошибка отправки запроса',
  'client.task.fillRequired': 'Название запроса обязательно',
  'client.task.pricing': 'Прайс-лист услуг',
  'client.task.pricingInfo': 'Информация о ценах',
  'client.task.selectServiceLabel': 'Услуга из прайс-листа',
  'client.task.selectServicePlaceholder': 'Выберите услугу (заполнит заголовок и описание)',
  'client.task.lblCategory': 'Категория',
  'client.task.lblService': 'Услуга',
  'client.task.lblPriceRsd': 'Цена (клиенты, RSD)',
  'client.task.lblUnit': 'Единица',
  'client.task.autoDescFooter': 'Добавьте срок, особые пожелания или вопросы ниже.',
  'client.task.fullPricingOnSite': 'Полный прайс на сайте',
  'client.support.title': 'Связаться с поддержкой',
  'client.support.subtitle': 'Опишите проблему. Мы ответим как можно скорее.',
  'client.support.fieldTitle': 'Заголовок',
  'client.support.fieldMessage': 'Сообщение',
  'client.support.urgency': 'Срочность',
  'client.support.urgencyLow': 'Низкая',
  'client.support.urgencyMedium': 'Средняя',
  'client.support.urgencyHigh': 'Высокая',
  'client.support.contactPref': 'Как с вами связаться?',
  'client.support.contactEmail': 'Email',
  'client.support.contactPhone': 'Телефон',
  'client.support.contactBoth': 'Email или телефон',
  'client.support.send': 'Отправить',
  'client.support.sending': 'Отправка...',
  'client.support.sent': 'Сообщение отправлено.',
  'client.support.failed': 'Не удалось отправить. Попробуйте снова.',
  'client.support.fillTitle': 'Укажите заголовок.',
  'client.support.fillMessage': 'Введите сообщение.',
  'client.taskRequests.title': 'Запросы',
  'client.taskRequests.loading': 'Загрузка запросов...',
  'client.taskRequests.noTasks': 'Пока нет отправленных запросов',
  'client.taskRequests.pending': 'В ожидании',
  'client.taskRequests.submitted': 'Запрос подан',
  'client.taskRequests.createdAt': 'Создан',
  'client.taskRequests.submittedAt': 'Передан бухгалтеру',
  'client.taskRequests.openTicket': 'Открыть тикет',
  'client.taskRequests.waitingForTicket': 'Ожидается ссылка на тикет от администратора',
  'client.taskRequests.targetAccountant': 'Бухгалтер',
  'client.taskRequests.targetSupport': 'Поддержка',
  'client.taskRequests.urgency': 'Срочность',
  'client.taskRequests.contactPref': 'Контакт',
  'client.taskRequests.tabAccountant': 'Бухгалтер',
  'client.taskRequests.tabSupport': 'Поддержка',
  'client.taskRequests.emptyAccountant': 'Пока нет запросов бухгалтеру.',
  'client.taskRequests.emptySupport': 'Пока нет запросов в поддержку.',
  'client.taskRequests.supportStatusReceived': 'Принято',
  'client.taskRequests.supportStatusInProgress': 'В работе',
  'client.taskRequests.supportStatusCompleted': 'Завершено',
  'client.taskRequests.updatedAt': 'Обновлено',
  'login.title': 'Войти',
  'login.subtitle': 'Клиентский портал',
  'login.desc': 'Введите данные для доступа к порталу',
  'login.email': 'Email адрес',
  'login.password': 'Пароль',
  'login.signIn': 'Войти',
  'login.signingIn': 'Вход...',
  'login.fillRequired': 'Введите email и пароль',
  'login.invalidCredentials': 'Неверный email или пароль',
  'login.forgotPassword': 'Забыли пароль',
  'login.forgotTitle': 'Сброс пароля',
  'login.forgotDesc': 'Введите email вашей учётной записи. Мы отправим ссылку для нового пароля.',
  'login.sendResetLink': 'Отправить ссылку',
  'login.sendingReset': 'Отправка…',
  'login.resetSent': 'Если аккаунт существует, проверьте почту: мы отправили инструкции.',
  'login.resetEmailRequired': 'Введите email.',
  'login.resetFailed': 'Не удалось отправить. Попробуйте снова.',
  'login.backToSignIn': 'Назад ко входу',
  'login.resetLoading': 'Загрузка…',
  'login.resetPasswordTitle': 'Новый пароль',
  'login.resetPasswordDesc': 'Введите новый пароль для аккаунта.',
  'login.newPassword': 'Новый пароль',
  'login.confirmPassword': 'Подтвердите пароль',
  'login.passwordMismatch': 'Пароли не совпадают.',
  'login.passwordTooShort': 'Пароль не короче 6 символов.',
  'login.saveNewPassword': 'Сохранить пароль',
  'login.savingPassword': 'Сохранение…',
  'login.passwordUpdated': 'Пароль обновлён.',
  'login.redirectingToLogin': 'Переход на страницу входа…',
  'login.resetInvalid': 'Ссылка недействительна или истекла. Запросите новую на странице входа.',
  'admin.companies.addNew': 'Добавить компанию',
  'admin.companies.save': 'Сохранить компанию',
  'admin.companies.saveChanges': 'Сохранить изменения',
  'admin.companies.edit': 'Редактировать компанию',
  'admin.companies.editTitle': 'Редактировать компанию',
  'admin.companies.editDrawerHint': 'Измените поля ниже и сохраните.',
  'admin.companies.view': 'Просмотр',
  'admin.companies.delete': 'Удалить',
  'admin.companies.edit2': 'Редактировать',
  'admin.companies.noMatch': 'Компании не найдены',
  'admin.companies.loading': 'Загрузка компаний...',
  'admin.companies.taxLabel': 'Налог',
  'admin.companies.colName': 'Компания',
  'admin.companies.colCountry': 'Страна',
  'admin.companies.colPlan': 'Тариф',
  'admin.companies.colStatus': 'Статус',
  'admin.companies.detailBadge': 'Компания',
  'admin.companies.sectionInfo': 'Сведения о компании',
  'admin.companies.sectionDocuments': 'Документы',
  'admin.companies.sectionFinance': 'Финансы и счета',
  'admin.companies.financeTotalPaid': 'Всего оплачено (за всё время)',
  'admin.companies.financePaidCount': 'Оплаченные счета',
  'admin.companies.financePending': 'Ожидают оплаты',
  'admin.companies.financeOverdue': 'Просроченные',
  'admin.companies.detailNoDocuments': 'Для этой компании пока нет документов.',
  'admin.companies.recentInvoices': 'Недавние счета',
  'admin.companies.openDoc': 'Открыть',
  'admin.companies.detailLoading': 'Загрузка…',
  'admin.companies.serviceStart': 'Начало обслуживания',
  'admin.companies.nextRenewal': 'Следующее продление',
  'admin.companies.searchPlaceholder': 'Поиск компаний...',
  'admin.companies.countOf': 'из',
  'admin.companies.companiesWord': 'компаний',
  'admin.companies.addShort': 'Добавить',
  'admin.companies.refreshTitle': 'Обновить',
  'admin.companies.filterAll': 'Все',
  'admin.companies.statusActive': 'Активна',
  'admin.companies.statusPending': 'В ожидании',
  'admin.companies.statusSuspended': 'Приостановлена',
  'admin.companies.statusArchived': 'В архиве',
  'admin.revenue.title': 'Месячная выручка',
  'admin.revenue.subtitle': 'Последние 12 мес. · оплаченные счета',
  'admin.revenue.totalLabel': 'Итого (12 мес.):',
  'admin.revenue.invoices': 'счетов',
  'admin.quick.title': 'Быстрые действия',
  'admin.quick.uploadDoc': 'Загрузить документ',
  'admin.quick.uploadDocDesc': 'Добавить документ компании',
  'admin.quick.addCompany': 'Добавить компанию',
  'admin.quick.addCompanyDesc': 'Зарегистрировать нового клиента',
  'admin.quick.issueInvoice': 'Выставить счёт',
  'admin.quick.issueInvoiceDesc': 'Создать новый счёт',
  'admin.quick.addUser': 'Добавить пользователя',
  'admin.quick.addUserDesc': 'Назначить доступ к порталу',
  'admin.quick.addCall': 'Добавить звонок',
  'admin.quick.addCallDesc': 'Записать входящий звонок',
  'admin.quick.generateReport': 'Создать отчёт',
  'admin.quick.generateReportDesc': 'Экспорт отчёта компании',
  'admin.quick.portalSettings': 'Настройки портала',
  'admin.quick.portalSettingsDesc': 'Управление конфигурацией',
  'admin.quick.pendingTasks': 'Ожидающие задачи',
  'admin.quick.noTasks': 'Нет ожидающих задач',
  'admin.quick.portalHealth': 'Состояние портала',
  'admin.quick.docCoverage': 'Охват документами',
  'admin.quick.collectionRate': 'Процент оплаты счетов',
  'admin.quick.activeCompanies': 'Активные компании',
  'admin.activity.title': 'Последние действия',
  'admin.activity.subtitle': 'Активность портала в реальном времени',
  'admin.activity.viewAll': 'Посмотреть весь журнал',
  'admin.activity.noActivity': 'Нет последних действий',
  'admin.activity.docUploaded': 'Документ загружен для',
  'admin.activity.invoiceOverdue': 'Счёт просрочен -',
  'admin.activity.paymentReceived': 'Платёж получен -',
  'admin.activity.invoiceIssued': 'Счёт выставлен -',
  'admin.activity.newPending': 'Новая компания ожидает одобрения',
  'admin.activity.newOnboarded': 'Новая компания зарегистрирована',
  'admin.activity.contactForm': 'Новое сообщение из контактной формы',
  'admin.kpi.activeCompanies': 'Активных компаний',
  'admin.kpi.currentlyActive': 'Сейчас активны',
  'admin.kpi.pendingDocs': 'Документы на рассмотрении',
  'admin.kpi.awaitingUpload': 'Ожидают загрузки',
  'admin.kpi.outstandingInvoices': 'Неоплаченные счета',
  'admin.kpi.pendingPayment': 'Ожидают оплаты',
  'admin.kpi.overdueInvoices': 'Просроченные счета',
  'admin.kpi.actionRequired': 'Требуется действие',
  'admin.kpi.revenue': 'Выручка -',
  'admin.kpi.paidThisMonth': 'Оплаченные счета в этом месяце',
  'admin.kpi.newCompanies': 'Новые компании (30д)',
  'admin.kpi.onboardedThisMonth': 'Зарегистрированы в этом месяце',
  'admin.kpi.urgent': 'СРОЧНО',
  'admin.kpi.contactForm': 'Контактная форма',
  'admin.kpi.contactFormSub': 'Всего заявок с сайта',
  'admin.kpi.contactFormUnread': 'Непрочитанные заявки',
  'admin.kpi.contactFormUnreadSub': 'Ещё не открыты в панели',
  'client.notif.document': 'Новый документ:',
  'client.notif.invoiceIssued': 'Счёт:',
  'client.notif.invoicePaid': 'Оплаченный счёт:',
  'client.notif.task': 'Заявка',
  'client.notif.call': 'Звонок',
  'client.invoices.loading': 'Загрузка счетов...',
  'client.invoices.noInvoices': 'Счета не найдены',
  'client.invoices.pending': 'ожидают оплаты',
  'client.invoices.viewAll': 'Посмотреть все',
  'client.invoices.colInvoice': 'Счёт',
  'client.invoices.colDesc': 'Описание',
  'client.invoices.colIssued': 'Выставлен',
  'client.invoices.colDue': 'Срок оплаты',
  'client.invoices.colAmount': 'Сумма',
  'client.invoices.colStatus': 'Статус',
  'client.invoices.view': 'Просмотр счёта',
  'client.invoices.downloadAttachment': 'Скачать вложенный файл',
  'client.invoices.openAttachment': 'Открыть вложенный файл',
  'client.invoices.noAttachment': 'К этому счёту не приложен файл.',
  'client.invoices.openFailed': 'Не удалось открыть файл.',
  'client.invoices.downloadedOk': 'Файл по счёту {{n}} открыт',
  'portal.languageHint': 'Измените язык в верхнем меню',
  'portal.emailLanguage': 'Язык уведомлений по email',
  'portal.emailLanguageHint':
    'Транзакционные письма из портала (счета, документы от команды, звонки, напоминания о просрочке) будут на этом языке.',
  'portal.emailLanguageSaved': 'Язык писем сохранён.',

  // VirtualOfficeSection
  'vo.sectionTitle': 'Сербский деловой адрес,\nбез офисных расходов',
  'vo.sectionDesc': 'Создайте надёжное, юридически зарегистрированное сербское деловое присутствие с первого дня - без затрат и обязательств физического офиса.',
  'vo.benefit1.title': 'Престижный белградский адрес',
  'vo.benefit1.desc': 'Топчидерская улица, община Савски венац - деловая зона в охраняемой зелёной зоне, рядом с центром Белграда.',
  'vo.benefit2.title': 'Приём и пересылка почты',
  'vo.benefit2.desc': 'Мы получаем, сканируем и пересылаем вашу деловую корреспонденцию куда угодно.',
  'vo.benefit3.title': 'Поддержка регистрации',
  'vo.benefit3.desc': 'Помогаем с регистрацией компании в APR, предоставляя необходимую адресную документацию.',
  'vo.benefit4.title': 'Для иностранных компаний',
  'vo.benefit4.desc': 'Идеально для международных компаний, которым нужно юридическое сербское присутствие без физического переезда.',
  'vo.benefit5.title': 'Юридически соответствует',
  'vo.benefit5.desc': 'Полностью соответствует сербскому коммерческому праву и требованиям регистрации APR.',
  'vo.benefit6.title': 'Активно за 48 часов',
  'vo.benefit6.desc': 'Ваш адрес и доступ к порталу готовы в течение двух рабочих дней после подписания.',
  'vo.legalHighlight':
    'Мы единственные в Сербии, кто предлагает на 100% законный виртуальный офис, в соответствии со всеми законами Республики Сербия.',
  'vo.whoFor': 'Для кого это',
  'vo.whoFor1': 'Иностранные компании, выходящие на сербский рынок',
  'vo.whoFor2': 'Интернет-магазины, которым нужен сербский адрес НДС',
  'vo.whoFor3': 'Фрилансеры и консультанты, которым нужен профессиональный деловой адрес',
  'vo.whoFor4': 'Компании, сокращающие физическое офисное пространство',
  'vo.whoFor5': 'Стартапы, которым нужен зарегистрированный адрес до найма персонала',
  'vo.plansTitle': 'Пакет виртуального офиса',
  'vo.plansDesc':
    'Один пакет включает всё перечисленное ниже. Адрес и налоговую инспекцию вы выбираете в соответствии с бизнес- и налоговыми приоритетами.',
  'vo.requestQuote': 'Запросить предложение',
  'vo.pack.title': 'Виртуальный офис',
  'vo.pack.tagline': 'Одна цена, один пакет - адрес, почта и портал.',
  'vo.pack.priceRsd': '3 500 RSD',
  'vo.pack.priceEur': '~30 EUR',
  'vo.pack.annualNote': '2 месяца бесплатно при годовой оплате',
  'vo.pack.f1': 'Деловой адрес в Белграде или Ковине (налоговая Панчево); Лозница скоро, сообщите об интересе',
  'vo.pack.f2': 'Email-уведомления о входящей почте',
  'vo.pack.f3':
    'Сканирование входящей почты, отправка сканов по email и загрузка в клиентский портал',
  'vo.pack.f4': 'Приём почты в общий абонентский ящик',
  'vo.pack.f5': 'Отдельная папка (регистратор) для документации',
  'vo.pack.f6': 'Скидки на коворкинг и переговорные',
  'vo.pack.f7': 'Доступ к цифровому порталу для отслеживания документации',

  'vo.addOns.tag': 'ДОПОЛНИТЕЛЬНЫЕ УСЛУГИ',
  'vo.addOns.title': 'Дополнительные услуги к виртуальному офису',
  'vo.addOns.subtitle': 'Расширьте пакет по необходимости: понятный перечень и фиксированные цены, где это возможно.',
  'vo.addOns.1.title': 'Телефония / приём звонков',
  'vo.addOns.1.desc':
    'Принимаем звонки за вас. Наш номер можно зарегистрировать в APR; обрабатываем все звонки и сообщаем, кто звонил.',
  'vo.addOns.1.price': '+500 RSD / мес.',
  'vo.addOns.2.title': 'Разбор документов и налоговые консультации',
  'vo.addOns.2.desc': 'Команда юристов разъяснит документы любого типа по специальной цене.',
  'vo.addOns.2.price': 'По договорённости',
  'vo.addOns.3.title': 'Подача экологического сбора (EKO)',
  'vo.addOns.3.desc': 'Сервисная подача EKO в общинах, где мы работаем.',
  'vo.addOns.3.price': '3 000 RSD / заявка',
  'vo.addOns.4.title': 'Отдельный почтовый ящик и табличка',
  'vo.addOns.4.desc': 'Собственный ящик и табличка с названием. Размер ящика 370 × 250 × 90 mm.',
  'vo.addOns.4.price': '+1 000 RSD / мес.',
  'vo.addOns.5.title': 'Переговорная',
  'vo.addOns.5.desc': 'Бронируйте переговорную в нашем офисе по акционным ценам.',
  'vo.addOns.5.price': 'По договорённости',
  'vo.addOns.6.title': 'Физическая пересылка почты',
  'vo.addOns.6.desc':
    'Одно письмо или несколько отправлений: курьерской или заказной почтой по вашей заявке.',
  'vo.addOns.6.price': '+500 RSD + почта (PTT)',

  'vo.extraBenefits.tag': 'ВИРТУАЛЬНЫЙ ОФИС',
  'vo.extraBenefits.title': 'Преимущества виртуального офиса',
  'vo.extraBenefits.desc': 'Дополнительные выгоды для вашей компании с зарегистрированным юридическим адресом.',
  'vo.extraBenefits.1.title': 'Защита адреса',
  'vo.extraBenefits.1.desc':
    'Зарегистрированный адрес остаётся стабильным и корректно отражается в реестре APR, а профессиональная работа с корреспонденцией снижает риск злоупотреблений.',
  'vo.extraBenefits.2.title': 'Защита номера телефона',
  'vo.extraBenefits.2.desc':
    'Деловой контакт можно направлять через наш адрес, чтобы личные номера и данные не смешивались с публичным профилем компании.',
  'vo.extraBenefits.3.title': 'Одна из более выгодных налоговых зон Белграда',
  'vo.extraBenefits.3.desc':
    'Расположение в зоне, которая по городу считается одной из более благоприятных, что может снизить совокупные операционные и налоговые издержки.',
  'vo.extraBenefits.4.title': 'Почтовый ящик и табличка всегда на адресе',
  'vo.extraBenefits.4.desc':
    'Физический ящик и табличка с названием компании всегда на адресе, чтобы снизить риск возврата почты и проблем при проверках, которые требуют такой вывески и приёма корреспонденции на месте.',
  'vo.extraBenefits.5.title': 'Архив почты и бухгалтерская книга',
  'vo.extraBenefits.5.desc':
    'Входящая почта регистрируется и архивируется по правилам, с безопасным хранением для ведения архивной книги.',
  'vo.extraBenefits.6.title': 'Приём налогового инспектора',
  'vo.extraBenefits.6.desc':
    'Уполномоченное лицо всегда доступно для приёма налогового инспектора и предоставления документов на месте.',

  'pausalBanner.text':
    'Наш офис находится в зоне охраны зелёных насаждений, община Савски венац. Также предлагаем зарегистрированный адрес в Ковине (налоговая Панчево). Локация Лозница скоро; сообщите об интересе к этому варианту.',
  'pausalBanner.button': 'Калькулятор паушального налога',
  'pausalBanner.textInlineLink':
    'Узнайте на этой странице, может ли ваш вид деятельности облагаться паушальным налогом.',
  'pausalBanner.aria': 'Паушальный налог: ссылка на калькулятор налоговой службы',

  // CoworkingSection
  'cw.sectionTitle': 'Профессиональное рабочее пространство\nв центре Белграда',
  'cw.sectionDesc': 'Создано для продуктивности и сотрудничества. Работайте рядом с другими профессионалами в чистой, тихой, деловой обстановке.',
  'cw.amenity1': 'Гигабитный интернет',
  'cw.amenity1.desc': '1 Гбит/с оптика',
  'cw.amenity2': 'Кофе и кухня',
  'cw.amenity2.desc': 'Полностью оснащено',
  'cw.amenity3': 'Два монитора',
  'cw.amenity3.desc': 'По запросу',
  'cw.amenity4': 'Переговорные комнаты',
  'cw.amenity4.desc': '3 доступны',
  'cw.amenity5': 'Гибкое бронирование',
  'cw.amenity5.desc': 'День или месяц',
  'cw.amenity6': 'Безопасный доступ 24ч',
  'cw.amenity6.desc': 'Вход по карте',
  'cw.plan.hotDesk.desc': 'Гибкое открытое рабочее место, доступное в любой рабочий день. Идеально для фрилансеров.',
  'cw.plan.hotDesk.f1': 'Любое доступное место',
  'cw.plan.hotDesk.f2': 'Доступ в рабочие дни',
  'cw.plan.hotDesk.f3': 'Хранение в шкафчике',
  'cw.plan.hotDesk.f4': 'Часы переговорной (2ч/мес)',
  'cw.plan.dedicated.desc': 'Ваш собственный зарезервированный стол, закрытое хранилище и постоянное рабочее место.',
  'cw.plan.dedicated.f1': 'Зарезервированный стол 24/7',
  'cw.plan.dedicated.f2': 'Запираемый шкафчик',
  'cw.plan.dedicated.f3': 'Доступна опция делового адреса',
  'cw.plan.dedicated.f4': 'Часы переговорной (5ч/мес)',
  'cw.plan.private.desc': 'Полностью закрытый частный офис для 1–4 человек. Включает запираемое хранилище и часы переговорной.',
  'cw.plan.private.f1': 'Закрытый частный офис',
  'cw.plan.private.f2': 'До 4 рабочих мест',
  'cw.plan.private.f3': 'Переговорная (10ч/мес)',
  'cw.plan.private.f4': 'Персональный брендинг на двери',

  // AccountingSection
  'acc.sectionTitle': 'Профессиональная деловая поддержка\nдля Сербии',
  'acc.sectionDesc': 'Пропущенный срок в налоговой, неверная декларация по НДС или некорректный адрес могут означать штрафы и сбои в работе - особенно если вы не говорите по-сербски и не знаете правил APR. Наша команда работает на пяти языках, берёт на себя эту сложность и следит за сроками вместо вас, чтобы вы занимались бизнесом.',
  'acc.svc1.title': 'Бухгалтерский учёт',
  'acc.svc1.desc': 'Ежемесячный бухгалтерский учёт, подготовка финансовой отчётности в соответствии с сербскими стандартами (МСФО/МРС).',
  'acc.svc1.tag1': 'Ежемесячные отчёты',
  'acc.svc1.tag2': 'МСФО/МРС соответствие',
  'acc.svc2.title': 'Налоговая и НДС регистрация',
  'acc.svc2.desc': 'Регистрация НДС, квартальные декларации, налог на прибыль и все законодательные сроки в Налоговой администрации.',
  'acc.svc2.tag1': 'Регистрация НДС',
  'acc.svc2.tag2': 'Квартальные декларации',
  'acc.svc3.title': 'Поддержка юридических документов',
  'acc.svc3.desc': 'Подготовка и проверка договоров, трудовых соглашений и деловых документов в соответствии с сербским правом.',
  'acc.svc3.tag1': 'Составление договоров',
  'acc.svc3.tag2': 'Трудовое право',
  'acc.svc4.title': 'Многоязычное консультирование',
  'acc.svc4.desc': 'Наша команда проводит консультации на сербском, английском, русском, турецком и немецком языках.',
  'acc.svc4.tag1': '5 языков',
  'acc.svc4.tag2': 'Международные клиенты',
  'acc.stat1.label': 'Лет опыта',
  'acc.stat1.sub': 'в сербском деловом праве',
  'acc.stat2.label': 'Клиентов',
  'acc.stat2.sub': 'местные и международные',
  'acc.stat3.label': 'Языков',
  'acc.stat3.sub': 'языки консультаций',
  'acc.stat4.label': 'Налоговых деклараций',
  'acc.stat4.sub': 'с 2014 года',
  'acc.cta.title': 'Запишитесь на бесплатную консультацию',
  'acc.cta.desc': 'Поговорите с одним из наших бухгалтеров или юридических консультантов о вашей ситуации. Доступно на сербском, английском, русском, турецком и немецком.',
  'acc.cta.btn': 'Записаться на звонок',
  'acc.pricing.show': 'Показать прайс-лист',
  'acc.pricing.hide': 'Скрыть прайс-лист',
  'acc.pricing.footer': 'Все цены в сербских динарах (RSD). Минимальные цены, подлежат согласованию. ✓ означает услуги, которые можно предоставить полностью онлайн.',

  // TrustSection
  'trust.statsTitle': 'Доверие компаний со всего мира',
  'trust.stat1': 'Зарегистрированных компаний',
  'trust.stat2': 'Управляемых документов',
  'trust.stat3': 'Лет в бизнесе',
  'trust.stat4': 'Обслуживаемых стран',
  'trust.trustedBy': 'Доверие компаний из Европы и других стран',
  'trust.testimonialsTag': 'Отзывы клиентов',
  'trust.testimonialsTitle': 'Что говорят наши клиенты',
  'trust.test1.text':
    'Нам нужен был сербский деловой адрес для расширения в ЕС. Офисные решения Top14 закрыли всё: регистрацию, документы и почту. Клиентский портал делает всё невероятно удобным.',
  'trust.test1.highlight': 'Зарегистрировано менее чем за 48 часов',
  'trust.test2.text':
    'Как предпринимателю из России, мне нужен был надёжный партнёр в Сербии. Top14 дал многоязычную поддержку; регистрация НДС и весь процесс прошли безупречно.',
  'trust.test2.highlight': 'Многоязычная поддержка сыграла ключевую роль',
  'trust.test3.text':
    'Коворкинг профессиональный и хорошо оснащённый. Офисные решения Top14 дают мне базу в Белграде, когда я в Сербии: отличный интернет, тишина и отзывчивая команда.',
  'trust.test3.highlight': 'Моё любимое рабочее место в Белграде',

  'partners.tag': 'Партнёры',
  'partners.title': 'Наши партнёры',
  'partners.desc':
    'Команды, которые дополняют экосистему Top14: цифровое присутствие, финансы, ИИ и образование.',
  'partners.evi.name': 'EVI Solutions',
  'partners.evi.desc':
    'Сильный сайт часто первый шаг к серьёзному бизнесу. Помимо этого EVI создаёт порталы, интернет‑магазины и приложения, а также профессионально сопровождает IT‑инфраструктуру, чтобы цифровой контур оставался стабильным при масштабировании.',
  'partners.tim011.name': 'Tim011 Digital',
  'partners.tim011.desc':
    'Партнёр для быстрого запуска ИП или компании с акцентом на скорость и онлайн‑бухгалтерию. Надёжная поддержка в ежедневной работе и более ясная налоговая оптимизация, чтобы вы вели бизнес, а не бумаги.',
  'partners.intrascope.name': 'Intrascope',
  'partners.intrascope.desc':
    'Единая AI‑инфраструктура для команды: ведущие модели в одном месте, общий контекст и контроль внутри компании. Промокод TOP150 даёт скидку 150 USD на первую покупку годового плана.',
  'partners.capitaale.name': 'Capitaale',
  'partners.capitaale.desc':
    'Capitaale — приложение для предпринимателей, которые выставляют счета иностранным клиентам. Реальный баланс в динарах после курса банка, лимит паушала в реальном времени, предупреждение когда один клиент превышает 70% дохода, и счёт в EUR или USD за 60 секунд. Первые 7 дней бесплатно.',

  // Footer hardcoded items
  'footer.businessAddress': 'Деловой адрес',
  'footer.legalAssistance': 'Юридическая помощь',
  'footer.companyRegistration': 'Регистрация компании',

  // Blog
  'blog.subtitle': 'Руководства по виртуальному офису, регистрации компании и деловому адресу в Белграде и Сербии.',
  'blog.readMore': 'Читать далее',
  'blog.backToBlog': 'Назад к блогу',
  'blog.related': 'Похожие статьи',
  'blog.published': 'Опубликовано',
  'blog.minRead': 'мин чтения',
  'blog.ctaTitle': 'Готовы к виртуальному офису в Белграде?',
  'blog.ctaDesc': 'Запишитесь на консультацию и узнайте, как Top14 поддержит ваш бизнес в Сербии.',
  'blog.ctaBtn': 'Контакт',
  'blog.authorTeam': 'Команда Top14',
  'blog.sources': 'Полезные ссылки',
  'blog.breadcrumbHome': 'Главная',
};

export default ru;
